export default {
  contentsContainer: {
    width: 1000,
    margin: "auto",
  },
};
